"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimeUntilSessionExpiryMs = exports.init = void 0;
const auth_client_1 = require("@dfinity/auth-client");
const identity_1 = require("@dfinity/identity");
let authClient;
const init = () => __awaiter(void 0, void 0, void 0, function* () {
    if (!authClient) {
        authClient = yield auth_client_1.AuthClient.create();
    }
});
exports.init = init;
const getAuthClient = () => authClient;
exports.default = getAuthClient;
function getTimeUntilSessionExpiryMs() {
    const identity = authClient === null || authClient === void 0 ? void 0 : authClient.getIdentity();
    if (!(identity instanceof identity_1.DelegationIdentity)) {
        return 0;
    }
    const expiryDateTimestampMs = Number(identity.getDelegation().delegations
        .map(d => d.delegation.expiration)
        .reduce((current, next) => next < current ? next : current) / BigInt(1000000));
    return expiryDateTimestampMs - Date.now();
}
exports.getTimeUntilSessionExpiryMs = getTimeUntilSessionExpiryMs;
